import styles from './LoginForm.module.scss';
import LoginFormInside from "./LoginFormInside";

const LoginFormComponent = (props: any) => {
    return (
        <div className={styles.container}>
             <LoginFormInside redirectTo={props.redirectUrl}></LoginFormInside>
        </div>
    )
}

export default LoginFormComponent;

